import gql from 'graphql-tag';

import type { Job } from 'src/data/job';
import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_JOB_ID } from 'src/graphql/job';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationRetryUnsuccessfulImproveRequestArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation RetryUnsuccessfulImproveRequest($recomposeRequestId: ID!) {
    retryUnsuccessfulImproveRequest(recomposeRequestId: $recomposeRequestId) {
      ...JobId
    }
  }
  ${FRAGMENT_JOB_ID}
`;

type Variables = BackendMutationRetryUnsuccessfulImproveRequestArgs;
type Result = Pick<Job, 'id'>;

export const retryUnsuccessfulImproveRequest = async (variables: Variables) => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });

  return getSingleProp<Result>(response.data);
};
